import React from "react";
import Layout from "components/Layout";
import Widget from "components/Widget";
import PetMainCategoryList from "components/Table/List";
import EditColor from "./components/EditColor";
import Action from "components/Table/Actions";
import TableHeader from "./components/TableHeader";
import ShowModal from "components/Modal/ShowModal";
import DeleteConfirm from "components/Modal/DeleteConfirm";
import { intlPlaceholder } from "util/intlPlaceholder";
import moment from "moment";
const Index = () => {
  const renderActions = (record) => {
    return (
      <div className="gx-d-flex gx-flex-column">
        <ShowModal
          modalName="EDIT_Color_MODAL"
          buttonName="Edit"
          record={record}
        />

        <DeleteConfirm
          type="deleteColor"
          apiRequest="DeleteRecord"
          recordName="colorList"
          title="Are you sure you want to delete this record"
          content="You can't undo this action"
          selectedItem={record}
          Icon="Delete"
        />
      </div>
    );
  };

  const columns = [
    {
      title: intlPlaceholder("color.id"),
      render: (record) => <span>{record.colorId}</span>,
      key: "id",
      width: "100px",
    },
    {
      title: intlPlaceholder("color.enterColour"),
      render: (record) => (
        <span className="gx-text-capitalize">{record.colorName}</span>
      ),
      key: "fullName",
      width: "150px",
    },
    {
      title: intlPlaceholder("color.createdBy"),
      render: (record) => (
        <span>{moment(record.createdAt).format("MMM-DD-YYYY")}</span>
      ),
      key: "createdBy",
    },
    {
      title: "",
      render: (record) => <Action>{renderActions(record)}</Action>,
      key: "action",
      width: "50px",
    },
  ];
  return (
    <Layout>
      <Widget>
        <TableHeader />
        <PetMainCategoryList
          apiName="getColor"
          recordName="colorList"
          columns={columns}
          scroll={true}
          pagination={true}
        />
      </Widget>
      <EditColor />
    </Layout>
  );
};

export default Index;
